/**
 * @generated SignedSource<<b3690bfc25841cad74c8d99c8a6df193>>
 * @relayHash 07411021415c8d22aa3be0401e7adcc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe241cdb7ba61fb05c38d4f19460575048f88ec716da09f821ff6a24c89f2cdd

import type { ConcreteRequest } from 'relay-runtime';
export type TemplatePreviewTemplateBodiesQuery$variables = {
  ids: ReadonlyArray<string>;
  spaceKey: string;
};
export type TemplatePreviewTemplateBodiesQuery$data = {
  readonly templateBodies: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly representation: string | null | undefined;
        readonly value: string | null | undefined;
      };
      readonly id: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type TemplatePreviewTemplateBodiesQuery = {
  response: TemplatePreviewTemplateBodiesQuery$data;
  variables: TemplatePreviewTemplateBodiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ids"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PaginatedTemplateBodyList",
    "kind": "LinkedField",
    "name": "templateBodies",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateBody",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              },
              {
                "kind": "ScalarField",
                "name": "representation"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TemplatePreviewTemplateBodiesQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TemplatePreviewTemplateBodiesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "07411021415c8d22aa3be0401e7adcc9",
    "id": "fe241cdb7ba61fb05c38d4f19460575048f88ec716da09f821ff6a24c89f2cdd",
    "metadata": {},
    "name": "TemplatePreviewTemplateBodiesQuery",
    "operationKind": "query",
    "text": "query TemplatePreviewTemplateBodiesQuery($spaceKey:String!,$ids:[String!]!){templateBodies(spaceKey:$spaceKey,ids:$ids){nodes{id,body{value,representation}}}}"
  }
};
})();

(node as any).hash = "e58abe6971533205bf426e7a6f2ac660";

export default node;
